<script>
    import { createEventDispatcher } from 'svelte';
    import MultiFieldProInput from './MultiFieldProInput.svelte';
    import MultiFieldProAsset from './MultiFieldProAsset.svelte';

    export let mtappVars;
    export let id;
    export let storage;
    export let storageKey;
    export let handle;
    export let fieldBlocks;

    const dispatch = createEventDispatcher();
    function triggerInputChange() {
        dispatch('inputchange');
    }
</script>

<div data-handle={handle}>
    <div class="mt-table--outline">
        <table class="table mt-table mtapp-mf-table-vertical">
            <tbody>
                {#each fieldBlocks[handle].fields as handleInFields}
                    <tr>
                        <th class="align-middle" scope="row">
                            {fieldBlocks[handleInFields].label}
                            {#if fieldBlocks[handleInFields].required}
                                <span class="badge badge-danger">{mtappVars.translate['Required']}</span>
                            {/if}
                        </th>
                        <td class="align-middle">
                            {#if fieldBlocks[handleInFields].description}
                                <p class="mt-0 mb-2">
                                    <small>{@html fieldBlocks[handleInFields].description}</small>
                                </p>
                            {/if}
                            {#if ['text', 'email', 'url', 'tel', 'password', 'number', 'datepicker', 'date', 'time', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'splitField', 'textarea', 'code', 'tinymce', 'select', 'select-multiple', 'checkbox', 'radio'].includes(fieldBlocks[handleInFields].type)}
                                <MultiFieldProInput
                                    mtappVars={mtappVars}
                                    id={`${id}-${handleInFields}`}
                                    storage={storage[storageKey]}
                                    storageKey={handleInFields}
                                    handle={handleInFields}
                                    fieldBlock={fieldBlocks[handleInFields]}
                                    on:inputchange={triggerInputChange} />
                            {:else if ['asset', 'image'].includes(fieldBlocks[handleInFields].type)}
                                <MultiFieldProAsset
                                    mtappVars={mtappVars}
                                    id={`${id}-${handleInFields}`}
                                    storage={storage[storageKey]}
                                    storageKey={handleInFields}
                                    handle={handleInFields}
                                    fieldBlock={fieldBlocks[handleInFields]}
                                    on:inputchange={triggerInputChange} />
                            {/if}
                            {#if fieldBlocks[handleInFields].help}
                                <div class="mt-2 mb-0 text-muted">
                                    <small>{@html fieldBlocks[handleInFields].help}</small>
                                </div>
                            {/if}
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
</div>
